import ContentsTypes from "@shared/enums/contentsTypes";
import ContentsCustomTypes from "@project/enums/contentsCustomTypes.enum";
export const Step = {
    label: "Étape",
    key: "items",
    type: ContentsCustomTypes.STEP,
    children: [
        {
            label: "Titre",
            key: "title",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Description",
            key: "description",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Couleur de bordure",
            key: "borderColor",
            type: ContentsTypes.COLOR,
            value: "#0000FF",
        },
        {
            label: "Couleur de fond",
            key: "backgroundColor",
            type: ContentsTypes.COLOR,
            value: "",
        },
    ],
};
export const Steps = {
    label: "Étapes",
    type: ContentsCustomTypes.STEPS,
    icon: "list-ol",
    editionModal: true,
    editionModalPosition: "top",
    children: [
        {
            key: "dynamicList",
            type: ContentsTypes.DYNAMIC_LIST,
            value: "",
            children: [
                {
                    key: "contentType",
                    children: [Step],
                    value: ContentsCustomTypes.STEP,
                },
            ],
        },
    ],
};
